// Index del projecto 

// Imports 
import React,{useEffect} from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter as Router,Redirect} from "react-router-dom";
import {Route} from 'AuthCas/Router';
import cas from 'AuthCas'
import FormVisit from "./FormVisit";
import Successful from "./Successful";
import Main from "./Main";
import NotAllowed from "./NotAllowed";
import TuiLayout from './containers/layout';
import MyRequests from "./MyRequests";
import HistoricalVisitors from "./HistoricalVisitors";
import VistaFormularioFuncionario from "./VistaFormularioFuncionario";
import NoActiveLink from './NoActiveLink';
import SendInvitations from './SendInvitations';
import InvitacionesEnviadas from "./InvitacionesEnviadas";
import Prorroga from "./Prorroga";
import FormularioRemoto from "./FormularioRemoto";
import InvitesHistory from "./InvitesHistory";

//Esta es nuestroa APP ahora
//En caso de tener problemas... poner <Cas/> y eliminar AuthCas true
let  AppRouter= ()=> {
    if(window.Roles === null){
        return (
            <Router >
                <TuiLayout>
                    <Route exact path='/' component={NotAllowed}/>
                    <Route path='/main' component={NotAllowed}/>
                </TuiLayout>
            </Router>
        );
    }else{
        return (
            <Router >
                <TuiLayout>
                    <Route exact path='/' component={Main}/>
                    <Route path='/main' component={Main}/>
                    <Route path='/form' component={FormVisit}/>
                    <Route path='/myrequests' component={MyRequests}/>
                    <Route path='/historical' component={HistoricalVisitors}/>
                    <Route path='/viewform/:visitID' component={VistaFormularioFuncionario}/>
                    <Route path='/sendinvitations' component={SendInvitations}/>
                    <Route path='/sentinvites' component={InvitacionesEnviadas}/>
                    <Route AuthCas={false && true} path='/prorroga' component={Prorroga}/>
                    <Route path='/invites' component={InvitesHistory}/>
                    <Route exact path='/remote_form/:url' component={FormularioRemoto}/>
                    <Route exact path='/remote_form/:url/successful' component={Successful}/>
                    <Route path='/fail' component={NoActiveLink}/>
                </TuiLayout>
            </Router>
        );
    }
}

let  AppRouter_ext= ()=> {
    return (
        <Router >
            <TuiLayout>
                <Route exact path='/' component={NotAllowed}/>
                <Route path='/main' component={NotAllowed}/>
                <Route exact path='/remote_form/:url' component={FormularioRemoto}/>
                <Route exact path='/remote_form/:url/successful' component={Successful}/>
            </TuiLayout>
        </Router>
    );
}

var actual_link = window.location.href;
var link_parts = actual_link.split('/');

if(link_parts[link_parts.length-2] == 'remote_form' || link_parts[link_parts.length-3] == 'remote_form'){
    ReactDOM.render(
        <React.StrictMode>
            <AppRouter_ext></AppRouter_ext>
        </React.StrictMode>,
        document.getElementById('root')
    );
}else{
    /* Se chequea el login del usuario Uchile usando el CAS del DSTI */
    cas.CheckLogin(window.ENV.AUTHCAS_URL,window.ENV.CAS_COOKIENAME,window.ENV.MODULE_KEY).then(()=> {
        const rootElement = document.getElementById("root")
        ReactDOM.render(
            <React.StrictMode>
                <AppRouter></AppRouter>
            </React.StrictMode>,
            document.getElementById('root')
        )
    })
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
